import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"

import "./Col.vue?vue&type=style&index=0&id=50c49e5c&lang=scss"

const __exports__ = script;

export default __exports__